import CountryCallingCodePicker from './index.vue';

CountryCallingCodePicker.install = (Vue) => {
  Vue.component(CountryCallingCodePicker.name, CountryCallingCodePicker);
};

export default CountryCallingCodePicker;
